import React from 'react';
import R from 'ramda';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Picture from '@cotyorg/ccx-atoms/Picture';

const generateButtonInnerClassNames = ({
  isSelected,
  isLine,
  isNumber,
  isThumbnail,
  isCircle,
}) => (
  classNames('carousel__pagination-button-inner', {
    'carousel__pagination-button-inner--line': isLine,
    'carousel__pagination-button-inner--line-selected': isLine && isSelected,
    'carousel__pagination-button-inner--number': isNumber,
    'carousel__pagination-button-inner--number-selected': isNumber && isSelected,
    'carousel__pagination-button-inner--thumbnail': isThumbnail,
    'carousel__pagination-button-inner--thumbnail-selected': isThumbnail && isSelected,
    'carousel__pagination-button-inner--circle': isCircle,
    'carousel__pagination-button-inner--circle-selected': isCircle && isSelected,
  })
);

const getButtonNumber = number => (`0${number + 1}`).slice(-2);

const getCurrentSlideText = ({ isSelected, currentSlideText }) => (
  isSelected ? `(${currentSlideText})` : ''
);

const PaginationButtonContents = ({
  type,
  isSelected,
  buttonIndex,
  itemText,
  currentSlideText,
  picture,
}) => {
  const isLine = type === 'lines';
  const isNumber = type === 'numbers';
  const isThumbnail = type === 'thumbnails';
  const isCircle = type === 'circles';
  const buttonNumber = getButtonNumber(buttonIndex);
  const currentSlide = getCurrentSlideText({ isSelected, currentSlideText });

  return (
    <span
      className={generateButtonInnerClassNames({
        isSelected,
        isLine,
        isNumber,
        isThumbnail,
        isCircle,
      })}
    >
      {isLine && (
        <span className="show-for-sr">
          {`${itemText} ${buttonNumber} ${currentSlide}`}
        </span>
      )}

      {isNumber && (
        <div className="carousel__pagination-button-text">
          <span className="show-for-sr">{itemText}</span>
          {` ${buttonNumber} `}
          { currentSlide && (<span className="show-for-sr">{currentSlide}</span>) }
        </div>
      )}

      {isThumbnail &&
        <Picture
          doNotLazyLoad
          key={R.prop('src', picture)}
          extraClass="thumbnail-gallery__picture"
          src={R.prop('src', picture)}
          alt={R.prop('alt', picture)}
        />}
    </span>
  );
};

PaginationButtonContents.defaultProps = {
  itemText: 'Item',
  currentSlideText: 'Current Slide',
};

PaginationButtonContents.propTypes = {
  itemText: PropTypes.string,
  currentSlideText: PropTypes.string,
  type: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  buttonIndex: PropTypes.number.isRequired,
  picture: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    thumbnail: PropTypes.objectOf(PropTypes.any),
  }),
};

export default PaginationButtonContents;
